import { render } from "./BaseDatePicker.vue?vue&type=template&id=623a34a0&scoped=true"
import script from "./BaseDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseDatePicker.vue?vue&type=script&lang=js"

import "./BaseDatePicker.vue?vue&type=style&index=0&id=623a34a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623a34a0"]])

export default __exports__